module.exports = __webpack_public_path__ + "static/microsoft-ad42f2304d8d5375ffe07cc9658e715d.png";